import realtimeDB from "./api";


export async function ChangeStatusLetter(id,newStatus,letter)
{
    await realtimeDB.ref("/Customers").child(id).update(
    {
        status:newStatus,
        letter:letter,
    });
}



export async function removeCustomer(id)
{
    await realtimeDB.ref("/Customers").child(id).remove();
}
